import * as React from 'react';
import styled from 'styled-components';
import { useFormContext, Controller, UseControllerReturn } from 'react-hook-form';
import { IBaseFormFieldProps, StyledErrorMessage } from '@agilepoint/wat-react-ux-form-fields';
import { ErrorMessage } from '@hookform/error-message';
import { Label, StackPanel } from '@agilepoint/wat-react-ux';
import { commonStyles } from '../style-literals';
import { FileUpload, IFileUploadProps } from '../file-upload';

export interface IFileUploadFormFieldProps extends Omit<IBaseFormFieldProps, 'label'>, Omit<IFileUploadProps, 'onChange'> {
}

const FieldBlock = styled(StackPanel)`
    ${commonStyles.boldTextLabel};
`;

export function FileUploadField(props: IFileUploadFormFieldProps) {
    const { name, className = 'ap-file-upload-field', title, orientation, gap = '4', validationRules, label, ...restProps } = props;
    const { control, formState: { errors } } = useFormContext();
    const renderFileUpload = React.useCallback(({ field: { onChange: _onChange, value } }: UseControllerReturn) => (
        <FileUpload {...restProps} onChange={_onChange} initialSelectedFiles={value?.selectedFiles || []} />
    ), [restProps]);

    return (
        <FieldBlock gap={gap} width="100%" orientation={orientation} className={className} title={title}>
            {label ? <Label required={validationRules && !!validationRules.required}>{label}</Label> : <></>}
            <Controller control={control} name={name} rules={validationRules} render={renderFileUpload} />
            <ErrorMessage errors={errors} name={name} as={StyledErrorMessage} />
        </FieldBlock >
    );
}
